import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { CreateFieldInterventionControlDto } from '@connect-services/src/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';
import SeverityEnum = CreateFieldInterventionControlDto.SeverityEnum;
import { FIELD_INTERVENTION_CONTROL_RESULTS_COLUMN_WIDTHS } from '@connect-services/client/components/field-intervention-form-entity-control-results/field-intervention-form-entity-control-results.component';
import { FieldInterventionControlResultDetails } from '@connect-services/client/services/field-intervention.service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-field-intervention-form-entity-control-results-detail',
    styleUrl: './../field-intervention-form-entity-control-results.component.scss',
    templateUrl: './field-intervention-form-entity-control-results-detail.component.html',
})
export class FieldInterventionFormEntityControlResultsDetailComponent {
    public readonly controlResult = input.required<FieldInterventionControlResultDetails>();

    protected readonly columnWidthClasses = FIELD_INTERVENTION_CONTROL_RESULTS_COLUMN_WIDTHS;
    protected readonly severityColorClasses: Record<SeverityEnum, string> = {
        critical: 'bg-error',
        major: 'bg-custom-orange',
        minor: 'bg-custom-yellow',
    };
}
